app.ReceiptImageWidthFieldView = app.FieldView.extend({
  className() {
    return `${app.FieldView.prototype.className.apply(this, arguments)} receipt-image-width-field-view`;
  },

  renderField() {
    const inputId = `${this.field}-${this.cid}`;
    this.$form = $('<input type="range" min="5" max="100" step="5" class="form-range" />');
    this.$form.attr('id', inputId);
    this.$label.attr('for', inputId);
    this.$inputContainer.append(this.$form);
    this.$widthValue = $('<output class="receipt-width-value" aria-live="polite"></output>');
    this.$widthValue.attr('for', inputId);
    this.$inputContainer.append(this.$widthValue);
    this.$inputContainer.append(
      $('<p class="receipt-width-help"></p>').text(
        'Move the slider to size the image on the sample receipt. Print a test receipt to check the result.',
      ),
    );
    this.$form.on('input', () => {
      this.$widthValue.text(`${this.getValue()}%`);
      this.onFieldChange();
    });
  },

  setValue(value, model, superValue) {
    app.FieldView.prototype.setValue.apply(this, [
      value ?? this.schema.defaultValue ?? 100,
      model,
      superValue,
    ]);
    this.$widthValue.text(`${this.getValue()}%`);
  },
});
